import React from 'react';
import { experience } from '../data/ExperienceData';
import '../scss/components/Experience.scss';

const Experience = () => {
  return (
    <>
      <h1 className='no-select'>Experience</h1>
      {experience.map((exp) => (
        <div key={exp.key} className='experience'>
          <h2>{exp.company}</h2>
          <p className='experience'>
            {exp.startDate.toLocaleString('default', { month: 'long' })}{' '}
            {exp.startDate.getFullYear()} -{' '}
            {exp.endDate ? exp.endDate.toLocaleString('default', { month: 'long' }) : 'Present'}{' '}
            {exp.endDate?.getFullYear()}
            {' : '+exp.title}
          </p>
          {/* <p >{exp.title}</p> */}
          <p className='experience'>
            {exp.location} {exp.workFromHome !== '' && `(${exp.workFromHome})`}
          </p>
         
          <ul>
          {exp.additionalInformation.map((add, index) => (
            <li className='experience' key={exp.key + index}>
              {add}
            </li>
          
          ))}</ul>
        </div>
      ))}
    </>
  );
};

export default Experience;
